module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-38.c35f3cd9.png";